import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useProductSet = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, uuid} = useContext(OrderContext);


  const postProducts = async (id, quantity) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/set_product/`, {
        order_product_id: id,
        ...(quantity ? { quantity } : {})
      });
      const data = response.data;
     
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return {postProducts};
};

export default useProductSet;
